import LoginSwitcher from "./login/LoginSwitcher.tsx";

function App() {
  return <LoginSwitcher />;
}

export default App;
